import { Alert, Snackbar } from "@mui/material";
import React from "react";

function WordsSnackbar({signUpAlertWords, handleCloseAlertWords}) {
    return (<Snackbar anchorOrigin={{
  vertical: 'top',
  horizontal: 'center'
  }} open={signUpAlertWords} autoHideDuration={7000} onClose={handleCloseAlertWords}>
    <Alert variant="outlined" onClose={handleCloseAlertWords} severity="info" sx={{
  width: '100%'
  }}>
      Hey there! Be a buddy and sign up in order to store more words! 👯
    </Alert>
  </Snackbar>);
  }

  export default WordsSnackbar;